import React from "react";

const SvgQuestionMark = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.348267"
      y="0.953125"
      width="21"
      height="21"
      rx="10.5"
      fill="white"
    />
    <path
      d="M9.79944 12.7812C9.8053 11.3223 10.1979 10.877 10.901 10.4375C11.4049 10.1094 11.7975 9.74609 11.7916 9.20703C11.7975 8.62109 11.3405 8.24023 10.7721 8.23438C10.2272 8.24023 9.71741 8.60352 9.69397 9.28906H8.02991C8.0592 7.64258 9.28381 6.85156 10.7838 6.85156C12.4186 6.85156 13.5729 7.70117 13.5729 9.14844C13.5729 10.1152 13.0748 10.7246 12.3073 11.1875C11.6451 11.5801 11.3522 11.9609 11.3463 12.7812V12.9102H9.79944V12.7812ZM9.62366 14.5742C9.61194 14.0352 10.0573 13.5957 10.608 13.6016C11.1295 13.5957 11.5807 14.0352 11.5807 14.5742C11.5807 15.1191 11.1295 15.5586 10.608 15.5586C10.0573 15.5586 9.61194 15.1191 9.62366 14.5742Z"
      fill="#B9B9B9"
    />
  </svg>
);

export default SvgQuestionMark;
